<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>List all Sharing Formulas</h2>
            <div class="float-right">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('createBeneficiary')">
                <i class="fa fa-plus"></i> &nbsp;<span>New Sharing Formula</span></button></div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-sharing-formula" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th >S/N</th>
                  <th>Description</th>
                  <th>Transaction Type</th>
                  <th>Action</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th >S/N</th>
                  <th>Description</th>
                  <th>Transaction Type</th>
                  <th>Action</th>

                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let share of sharingFormulas;let i = index;">

                  <td [id]="'td-' + i" > {{ i + 1}}</td>

                  <td>{{ share?.description }}</td>
                  <td>{{ share?.transaction_type }}</td>
                  <td>
                    <div>
                        <span role="button" data-balloon="View Sharing Formula Details" data-balloon-pos="up" >
                                          <i class="fa fa-eye text-primary"></i>
                                        </span>&nbsp;&nbsp;
                      <span role="button" data-balloon="Edit Sharing Formula" data-balloon-pos="up" (click)="triggerEdit(share)">
                                          <i class="fa fa-edit text-info"></i>
                                        </span>&nbsp;&nbsp;
                      <span role="button" data-balloon="Delete" data-balloon-pos="up" (click)="deleteSharingFormula(share)">
                        <i class="fa fa-trash text-danger"></i>
                      </span>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>




<!-- Beneficiary Modal -->

<div class="modal fade" id="createSharingFormula" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="title" id="defaultModalLabel">{{modal.title}}</h6>
      </div>
      <form class="form-auth-small" #signupForm="ngForm" (ngSubmit)="createSharingFormula()">

        <div class="modal-body">


        </div>

        <div class="modal-footer">
         <!-- <button type="submit" *ngIf="!loaders.saving" [disabled]="first_name.errors || last_name.errors || bvn.errors || email.errors" class="btn btn-primary">{{modal.btnText}}</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="resetForm()">CLOSE</button>
     -->   </div>
      </form>
    </div>
  </div>
</div>


